export enum MessageStyle {
  Success = 'success',
  Error = 'error',
  Info = 'info'
}
